import { simplifyPhone } from "./format";
export const getUserInfoOptions = (userInfo) => {
    if (!userInfo) {
        return [
            {
                id: 1,
                title: "",
                description: "",
                isDefault: true,
                isBusiness: false,
                isSelf: false,
                values: {
                    user_add_flag: false,
                    user_fio: null,
                    user_address: null,
                    user_inn: null,
                    user_phone: null,
                    user_mail: null,
                    user_company: null,
                    user_ogrn: null,
                    user_okved: null,
                    user_reg_date: null,
                    user_site: null,
                    user_contact_phone: null,
                    user_contact_mail: null,
                    user_tg: null,
                    user_vk: null,
                    user_comment: null,
                },
                initialValues: {
                    user_add_flag: false,
                    user_fio: null,
                    user_address: null,
                    user_inn: null,
                    user_phone: null,
                    user_mail: null,
                    user_company: null,
                    user_ogrn: null,
                    user_okved: null,
                    user_reg_date: null,
                    user_site: null,
                    user_contact_phone: null,
                    user_contact_mail: null,
                    user_tg: null,
                    user_vk: null,
                    user_comment: null,
                },
            },
        ];
    }
    let result = [];
    let currentId = 0;
    currentId += 1;
    result = [
        ...result,
        {
            id: currentId,
            title: userInfo.USER_FULLNAME,
            isDefault: userInfo.ACTIVE,
            isBusiness: false,
            isSelf: false,
            values: {
                user_add_flag: false,
                user_fio: userInfo.USER_FULLNAME || null,
                user_address: userInfo.USER_RESIDENCEADDRESS || null,
                user_inn: userInfo.USER_INN || null,
                user_phone: simplifyPhone(userInfo.PERSONAL_PHONE || null),
                user_mail: userInfo.EMAIL || null,
                user_company: null,
                user_ogrn: null,
                user_okved: null,
                user_reg_date: null,
                user_site: null,
                user_contact_phone: null,
                user_contact_mail: null,
                user_tg: null,
                user_vk: null,
                user_comment: null,
            },
            initialValues: {
                user_add_flag: false,
                user_fio: userInfo.USER_FULLNAME || null,
                user_address: userInfo.USER_RESIDENCEADDRESS || null,
                user_inn: userInfo.USER_INN || null,
                user_phone: simplifyPhone(userInfo.PERSONAL_PHONE || null),
                user_mail: userInfo.EMAIL || null,
                user_company: null,
                user_ogrn: null,
                user_okved: null,
                user_reg_date: null,
                user_site: null,
                user_contact_phone: null,
                user_contact_mail: null,
                user_tg: null,
                user_vk: null,
                user_comment: null,
            },
        },
    ];
    if (userInfo.SELF) {
        currentId += 1;
        result = [
            ...result,
            {
                id: currentId,
                title: `${userInfo.SELF.USER_FULLNAME} (Самозанятый)`,
                description: userInfo.SELF.USER_INN,
                isDefault: userInfo.SELF.ACTIVE,
                isBusiness: false,
                isSelf: true,
                values: {
                    user_add_flag: true,
                    user_fio: userInfo.SELF.USER_FULLNAME || null,
                    user_address: userInfo.SELF.USER_RESIDENCEADDRESS || null,
                    user_inn: userInfo.SELF.USER_INN || null,
                    user_phone: simplifyPhone(userInfo.SELF.UF_PHONE || null),
                    user_mail: userInfo.SELF.UF_EMAIL || null,
                    user_company: null,
                    user_ogrn: null,
                    user_okved: null,
                    user_reg_date: null,
                    user_site: null,
                    user_contact_phone: null,
                    user_contact_mail: null,
                    user_tg: null,
                    user_vk: null,
                    user_comment: null,
                },
                initialValues: {
                    user_add_flag: true,
                    user_fio: userInfo.SELF.USER_FULLNAME || null,
                    user_address: userInfo.SELF.USER_RESIDENCEADDRESS || null,
                    user_inn: userInfo.SELF.USER_INN || null,
                    user_phone: simplifyPhone(userInfo.SELF.UF_PHONE || null),
                    user_mail: userInfo.SELF.UF_EMAIL || null,
                    user_company: null,
                    user_ogrn: null,
                    user_okved: null,
                    user_reg_date: null,
                    user_site: null,
                    user_contact_phone: null,
                    user_contact_mail: null,
                    user_tg: null,
                    user_vk: null,
                    user_comment: null,
                },
            },
        ];
    }
    if (userInfo.COMPANY_DATA) {
        result = [
            ...result,
            ...userInfo.COMPANY_DATA.map(item => {
                currentId += 1;
                return {
                    id: currentId,
                    title: item.UF_SHORTNAME,
                    description: item.UF_INN,
                    isDefault: item.ACTIVE,
                    isBusiness: true,
                    isSelf: false,
                    values: {
                        user_add_flag: true,
                        user_fio: null,
                        user_address: item.UF_LEGALADDRESS || null,
                        user_inn: item.UF_INN || null,
                        user_phone: simplifyPhone(item.UF_PHONE || null),
                        user_mail: item.UF_EMAIL || null,
                        user_company: item.UF_FULLNAME || null,
                        user_ogrn: item.UF_OGRN || item.UF_OGRNIP || null,
                        user_okved: [item.UF_MAINOKWED2CODE, item.UF_MAINOKWED2NAME].filter(Boolean).join(" ") || null,
                        user_reg_date: item.UF_REGDATE,
                        user_site: item.UF_SITE,
                        user_contact_phone: simplifyPhone(userInfo.PERSONAL_PHONE || null),
                        user_contact_mail: userInfo.EMAIL || null,
                        user_tg: null,
                        user_vk: null,
                        user_comment: null,
                    },
                    initialValues: {
                        user_add_flag: true,
                        user_fio: null,
                        user_address: item.UF_LEGALADDRESS || null,
                        user_inn: item.UF_INN || null,
                        user_phone: simplifyPhone(item.UF_PHONE || null),
                        user_mail: item.UF_EMAIL || null,
                        user_company: item.UF_FULLNAME || null,
                        user_ogrn: item.UF_OGRN || item.UF_OGRNIP || null,
                        user_okved: [item.UF_MAINOKWED2CODE, item.UF_MAINOKWED2NAME].filter(Boolean).join(" ") || null,
                        user_reg_date: item.UF_REGDATE,
                        user_site: item.UF_SITE,
                        user_contact_phone: simplifyPhone(userInfo.PERSONAL_PHONE || null),
                        user_contact_mail: userInfo.EMAIL || null,
                        user_tg: null,
                        user_vk: null,
                        user_comment: null,
                    },
                };
            }, []),
        ];
    }
    return result;
};
